import React from 'react';
import PropTypes from 'prop-types';
import { showMarketingOptIn, destinationInfo } from '../../../destructured-front-end-config';
import CheckboxWithLabelV2 from '../../../components/composite/FormSets/CheckboxWithLabelV2/CheckboxWithLabelV2';
import Language from '../../../components/Language/Language';

const MarketingOptInControlSet = ({
  brand, optIn, setOptIn, getCalculatedOptIn,
}) => (
  <>
    {
          showMarketingOptIn && (
            <CheckboxWithLabelV2
              id="OptIn__c"
              value={getCalculatedOptIn()}
              label={<Language category="copy" which="privacyBlurbUAM" brand={brand} options={{ destinationInfo }} />}
              onClick={() => setOptIn(optIn === null ? !getCalculatedOptIn() : !optIn)}
            />
          )
        }
  </>
);

MarketingOptInControlSet.propTypes = {
  brand: PropTypes.object.isRequired,
  optIn: PropTypes.bool,
  setOptIn: PropTypes.func.isRequired,
  getCalculatedOptIn: PropTypes.func.isRequired,
};

MarketingOptInControlSet.defaultProps = {
  optIn: null,
};

export default MarketingOptInControlSet;
